// App-wide storefront overlays (bag drawer, quick view) live once in StoreLayout; any
// component opens them through these events instead of threading props everywhere.
export const OPEN_BAG = 'rt-open-bag';
export const OPEN_QUICK_VIEW = 'rt-quick-view';

export const openBag = () => window.dispatchEvent(new Event(OPEN_BAG));
export const openQuickView = (product) => window.dispatchEvent(new CustomEvent(OPEN_QUICK_VIEW, { detail: product }));
